const ReconciliationReason = {
  NONE: 'none',
  DUPLICATE: 'duplicate',
  MISSING_IDENTIFIER: 'missing_identifier',
  AMOUNT_DISCREPANCY: 'amount_discrepancy',
  OTHER: 'other',
};

module.exports = ReconciliationReason;
